import React, { FC, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { workOrdersRestCrudThunksForSupplier } from '../../thunks/work_orders_thunks';
import SupplierWorkOrderEditForm from '../supplier_work_order_edit_form/SupplierWorkOrderEditForm';
import { EditPage } from '../edit_page/EditPage';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import { goBackLink, recursiveRemovePreserve } from '../../utils/HistoryUtils';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import ContractorWorkOrderEditForm from '../supplier_work_order_edit_form/ContractorWorkOrderEditForm';
import { getWorkOrderSelector } from '../../selectors/workOrderSelectors';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';

require('./EditSupplierWorkOrderPage.less');
const queryString = require('qs');

const EditSupplierWorkOrderPage: FC<any> = ({
	match,
	getWorkOrder,
	history,
	workOrder,

	location,
}): React.ReactElement => {
	const [fetching, setFetching] = useState(true);
	const workOrderId = match.params.id;

	useEffect(() => {
		getWorkOrder(workOrderId).then(() => {
			setFetching(false);
		});
	}, []);

	const defaultUrlPath = `/supplier/workOrders/detail/${workOrderId}/details`;

	const EditForm = useMemo(
		() =>
			nullSafeGet('locationId', workOrder) === -100
				? ContractorWorkOrderEditForm
				: SupplierWorkOrderEditForm,
		[workOrder]
	);

	return fetching ? (
		<PageLoadingPlaceholder />
	) : (
		<EditPage
			title="Edit Work Order"
			formComponentProps={{
				formData: workOrder,
				onSuccess: (rec) => {
					let string = goBackLink(location, defaultUrlPath);
					const [path, queryParams] = string.split('?');
					let urlSearchParams = queryString.parse(queryParams);
					history.push(`${path}?${recursiveRemovePreserve(urlSearchParams)}`);
				},
			}}
			fetching={fetching}
			FormComponent={EditForm}
		/>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	};
};

const mapDispatchToProps = (dispatch) => ({
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(EditSupplierWorkOrderPage)
);
